import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("hr", { class: "border-1 inline-block w-1/2 border-dashed border-gray-200 dark:border-gray-700" }, null, -1)
const _hoisted_2 = [
  _hoisted_1
]


export default /*#__PURE__*/_defineComponent({
  __name: 'AppDivider',
  props: {
  type: {
    type: String,
    default: 'large'
  }
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["flex flex-col items-center", [__props.type === 'small' ? 'py-10': 'py-20']])
  }, _hoisted_2, 2))
}
}

})